module.exports = __webpack_public_path__ + "media/images/upload_folder-70d61458.svg";